import { FC } from "react";

interface HandDocumentMoneyWhiteProps {
  className?: string;
}

export const HandDocumentMoneyWhite: FC<HandDocumentMoneyWhiteProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      width="66"
      height="67"
      viewBox="0 0 66 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.7278 48.7311C57.4813 49.1311 57.2245 49.5249 56.9599 49.9107C56.6153 50.4142 56.2539 50.9058 55.877 51.386C55.0484 52.4455 54.1462 53.4472 53.1808 54.3802C50.0677 57.3902 46.2848 59.7094 42.0772 61.093C41.0382 61.4339 39.9721 61.7191 38.8841 61.9423C36.9842 62.3347 35.016 62.54 33 62.54C29.4739 62.54 26.0936 61.9114 22.9663 60.76C16.8163 58.495 11.6433 54.2086 8.25659 48.7065C5.53199 44.2835 3.95996 39.0755 3.95996 33.5C3.95996 17.4607 16.9621 4.45996 33 4.45996C46.6036 4.45996 58.0221 13.812 61.1752 26.44C61.2656 26.8001 61.3495 27.1641 61.4256 27.5293C61.8283 29.4563 62.04 31.453 62.04 33.5C62.04 39.0858 60.4628 44.304 57.7278 48.7311Z"
        fill="#DCEDFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.0701 29.9378L22.1491 13.7618C21.9337 12.8758 22.6282 11.8202 23.5537 11.5465L31.1554 9.30002C32.0809 9.02637 32.8871 9.63861 33.1021 10.5249L37.0937 26.1455C37.3087 27.0318 36.7331 27.9719 35.8074 28.2451L28.2057 30.4917C27.2806 30.765 26.3557 30.2687 26.1403 29.3827"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9457 29.5596L20.3163 12.3899C20.0621 11.4494 20.7357 10.3644 21.6756 10.111L29.3957 8.03069C30.3357 7.77727 31.1861 8.45168 31.44 9.39241L36.1211 25.9803C36.375 26.921 35.8192 27.8889 34.879 28.1419L27.1588 30.2222C26.2193 30.4754 25.2513 29.9185 24.997 28.9781"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.4198 28.0016L21.3378 12.8925C21.1217 12.0931 21.5943 11.2707 22.3933 11.0553L28.9554 9.28706C29.7543 9.07165 30.5772 9.54498 30.7929 10.3446L34.8753 25.4535C35.091 26.2531 34.6186 27.0757 33.8195 27.2908L27.2573 29.0591C26.4587 29.2743 25.6359 28.801 25.4198 28.0016Z"
        fill="#8AE7F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3469 20.4261C31.8013 20.1492 30.6022 9.69471 30.8163 10.4948L34.9488 25.4015C35.163 26.2017 34.6864 27.0269 33.8838 27.2447L27.2934 29.0351C26.4914 29.253 25.6671 28.7814 25.4526 27.9815C25.4526 27.9815 24.0102 22.9016 23.3469 20.4261Z"
        fill="#A2EBE2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.785 21.7701C27.1754 22.2044 25.5178 21.2514 25.0835 19.6417C24.649 18.0317 25.6017 16.3744 27.2119 15.9402C28.8218 15.5057 30.4789 16.4586 30.9134 18.0686C31.3479 19.6785 30.3947 21.3358 28.785 21.7701Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.8117 14.0093L25.4741 12.7577C25.3705 12.3739 25.5978 11.9786 25.9818 11.8752L26.0639 11.8529C26.4478 11.7495 26.8429 11.9765 26.9466 12.3602L27.2842 13.6119C27.3875 13.9959 27.1606 14.391 26.7768 14.4947L26.6941 14.5169C26.3102 14.6203 25.9154 14.3931 25.8117 14.0093Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.7309 33.3688L15.1354 20.1902C14.5545 19.4687 14.7524 18.2277 15.5013 17.6073L21.653 12.5124C22.4019 11.892 23.4185 12.1272 23.9992 12.8492L34.423 25.4931C35.0037 26.215 34.8676 27.3029 34.1183 27.9231L27.9666 33.018C27.2179 33.638 26.1399 33.5561 25.559 32.8345"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.5167 33.4744L12.8328 19.6736C12.1922 18.9179 12.358 17.6586 13.129 17.0509L19.4628 12.06C20.2338 11.4523 21.3185 11.7264 21.9588 12.4825L33.4421 25.732C34.0824 26.4881 33.9767 27.5933 33.2053 28.2008L26.8715 33.1917C26.1007 33.799 24.9564 33.6792 24.3158 32.9236"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2933 31.8638L14.0039 19.7225C13.4594 19.0802 13.5496 18.141 14.205 17.6244L19.5887 13.3822C20.2441 12.8656 21.2168 12.9674 21.7611 13.6101L32.0507 25.751C32.595 26.3936 32.5051 27.3331 31.8494 27.8495L26.4657 32.0917C25.8105 32.6079 24.8378 32.5061 24.2933 31.8638Z"
        fill="#8AE7F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2733 25.8577C27.0663 22.2171 21.3043 13.0937 21.8473 13.7375L32.0973 25.6739C32.6403 26.3177 32.5477 27.2612 31.8899 27.7814L26.4892 32.0551C25.832 32.5752 24.8587 32.4756 24.3155 31.8322C24.3155 31.8322 20.954 27.8492 19.2733 25.8577Z"
        fill="#A2EBE2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7743 24.8329C23.4539 25.874 21.4947 25.6693 20.3991 24.3756C19.3031 23.0817 19.4849 21.1887 20.8059 20.1474C22.1264 19.106 24.0851 19.3109 25.1811 20.6048C26.2771 21.8987 26.0946 23.7919 24.7743 24.8329Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6689 18.9478L17.8171 17.9418C17.5557 17.6335 17.5992 17.1819 17.9143 16.9337L17.9815 16.8804C18.2966 16.6323 18.7635 16.681 19.0248 16.9893L19.8767 17.9953C20.1378 18.3041 20.0946 18.7553 19.7798 19.0036L19.712 19.0571C19.397 19.3052 18.9302 19.2562 18.6689 18.9478Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.5738 34.7318L12.9002 27.8177C12.0413 27.4395 11.6126 26.2452 11.9676 25.3527L14.8842 18.0226C15.2392 17.1301 16.2437 16.8775 17.1025 17.2562L32.3664 23.7724C33.2253 24.1511 33.6338 25.1811 33.2784 26.0736L30.3618 33.4036C30.0069 34.2956 29.0229 34.7126 28.164 34.3344"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.8965 34.8817L10.6327 28.4043C9.705 28.0229 9.23929 26.8268 9.61981 25.9355L12.7463 18.6153C13.1268 17.724 14.2099 17.4751 15.1375 17.857L31.6232 24.4308C32.5508 24.8127 32.9944 25.8444 32.6134 26.7357L29.4869 34.0558C29.1064 34.9467 28.046 35.36 27.1183 34.9786"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6822 27.9156C10.8937 27.5914 10.517 26.7145 10.8405 25.9569L13.498 19.7348C13.8215 18.9772 14.7228 18.6258 15.5113 18.9504L30.4136 25.08C31.2022 25.4046 31.5792 26.2816 31.2554 27.0391L28.5978 33.2613C28.2744 34.0185 27.373 34.3698 26.5845 34.0456L11.6822 27.9156Z"
        fill="#8AE7F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2739 30.9815C24.3336 24.1999 14.8608 18.6984 15.6487 19.0246L30.4171 24.9902C31.205 25.3164 31.5816 26.1982 31.2578 26.9601L28.6007 33.218C28.2774 33.9796 27.3765 34.3332 26.5886 34.0074C26.5886 34.0074 21.7121 31.9901 19.2739 30.9815Z"
        fill="#A2EBE2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5409 29.1508C17.9533 28.4972 17.1942 26.7298 17.8461 25.2028C18.4975 23.6758 20.3125 22.9681 21.9001 23.6216C23.4878 24.2751 24.2464 26.043 23.595 27.5696C22.9436 29.0961 21.1282 29.8043 19.5409 29.1508Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3924 25.1063L14.1582 24.598C13.7797 24.4423 13.5987 24.0206 13.7543 23.6566L13.7874 23.5786C13.943 23.2146 14.3755 23.0457 14.754 23.2014L15.9882 23.7097C16.3667 23.8658 16.5477 24.287 16.3925 24.6511L16.359 24.7295C16.2034 25.0935 15.7709 25.2619 15.3924 25.1063Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7748 29.7922L25.5406 29.2839C25.1617 29.1282 24.9811 28.707 25.1367 28.343L25.1697 28.2646C25.3253 27.9006 25.7579 27.7321 26.1364 27.8878L27.3705 28.396C27.749 28.5517 27.9301 28.973 27.7745 29.337L27.741 29.4154C27.5858 29.7794 27.1532 29.9479 26.7748 29.7922Z"
        fill="#48CAD4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.4741 17.0846C63.6574 17.8007 64.0382 23.1517 61.4336 26.4463C59.9628 28.3066 59.3656 30.7152 59.8043 32.4503L37.6741 26.6282L44.0298 13.543C44.0298 13.543 57.2908 16.3684 60.4741 17.0846Z"
        fill="#9CC5FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.0453 50.8015C50.1222 45.5484 52.1134 38.4971 52.1134 30.7826C52.1134 21.5005 57.2669 16.4596 60.4741 17.0846L37.8357 11.756C29.3559 9.43257 29.0666 16.549 27.3264 28.7502C26.5385 34.2746 24.8388 39.5637 23.2156 43.6956L48.0453 50.8015Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.2359 36.6935L28.277 36.7008C34.5481 38.4883 40.8493 40.1563 47.1768 41.7037C47.2873 41.7307 47.355 41.8423 47.328 41.9528C47.301 42.0634 47.1894 42.1311 47.0789 42.104C40.7464 40.5554 34.4402 38.8861 28.164 37.0972C28.0546 37.066 27.9912 36.952 28.0224 36.8425C28.0496 36.7467 28.1404 36.6862 28.2359 36.6935ZM28.792 33.913L28.8331 33.9203C35.1016 35.7071 41.4028 37.3751 47.7329 38.9232C47.8434 38.9503 47.9111 39.0618 47.8841 39.1724C47.8571 39.2829 47.7455 39.3506 47.635 39.3236C41.2998 37.7742 34.9936 36.1049 28.7201 34.3167C28.6107 34.2855 28.5472 34.1715 28.5784 34.062C28.6057 33.9663 28.6964 33.9057 28.792 33.913ZM29.3481 31.1325L29.3892 31.1398C35.6577 32.9266 41.9589 34.5946 48.289 36.1427C48.3995 36.1698 48.4672 36.2813 48.4402 36.3918C48.4132 36.5024 48.3016 36.5701 48.1911 36.5431C41.8559 34.9937 35.5497 33.3244 29.2762 31.5362C29.1668 31.505 29.1034 31.391 29.1345 31.2815C29.1618 31.1858 29.2526 31.1252 29.3481 31.1325ZM29.3481 28.9081L29.3892 28.9154C35.657 30.702 41.9583 32.37 48.289 33.9183C48.3995 33.9454 48.4672 34.0569 48.4402 34.1674C48.4132 34.278 48.3016 34.3457 48.1911 34.3187C41.8554 32.7691 35.5491 31.0998 29.2762 29.3118C29.1668 29.2806 29.1034 29.1666 29.1345 29.0571C29.1618 28.9614 29.2526 28.9008 29.3481 28.9081ZM29.9042 26.6837L29.9453 26.6911C36.2138 28.4779 42.515 30.1458 48.8451 31.694C48.9556 31.721 49.0233 31.8325 48.9963 31.9431C48.9693 32.0536 48.8577 32.1213 48.7472 32.0943C42.412 30.5449 36.1058 28.8756 29.8323 27.0874C29.7229 27.0562 29.6594 26.9422 29.6906 26.8328C29.7179 26.737 29.8086 26.6765 29.9042 26.6837ZM31.1311 18.5478L49.9083 23.5462L49.7949 24.0846L49.7257 24.4424L49.6312 24.9729L49.5473 25.4902L49.4736 25.9881L49.3904 26.6109L49.3091 27.3024L49.2419 27.9662L49.1926 28.5575L44.4071 27.3034L39.9163 26.1003L36.7763 25.2376L34.9248 24.7154L33.2576 24.2307L32.4171 23.9777L31.8511 23.8021L31.5078 23.6925L31.1937 23.5895L30.9107 23.4935L30.6605 23.4048L30.4449 23.324C30.4948 22.0483 30.7172 20.2328 31.1311 18.5478ZM33.2299 13.893L33.2713 13.8981L52.7347 18.3469C52.8457 18.3723 52.9151 18.4828 52.8897 18.5937C52.8675 18.6908 52.7801 18.756 52.6843 18.7539L52.6429 18.7487L33.1795 14.2999C33.0685 14.2745 32.9992 14.164 33.0245 14.0531C33.0467 13.956 33.1341 13.8908 33.2299 13.893ZM35.4543 12.2247L35.4957 12.2298L54.9591 16.6786C55.07 16.704 55.1394 16.8145 55.1141 16.9254C55.0919 17.0225 55.0045 17.0878 54.9087 17.0856L54.8673 17.0804L35.4039 12.6316C35.2929 12.6063 35.2235 12.4958 35.2489 12.3848C35.2711 12.2877 35.3585 12.2225 35.4543 12.2247Z"
        fill="#B9D9F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5043 23.0817C33.1739 24.3215 32.7116 25.8694 31.4718 26.5389L30.9741 26.8103L30.3849 27.1388L29.7243 27.5188L29.2106 27.8249L28.8225 28.0635L28.454 28.2972L28.0196 28.5832L27.6128 28.8634L27.4575 28.974L27.2861 29.0992L26.9378 31.1318L26.3498 33.9083C27.3983 33.5722 28.3799 33.3548 29.2304 33.2933C30.9601 33.1681 32.4638 34.4688 32.5889 36.1985C32.7111 37.8871 31.4745 39.3602 29.8065 39.5458L29.6837 39.5571C28.8291 39.619 27.5446 40.0645 26.1602 40.7117L25.6954 40.9347C25.4617 41.0496 25.2262 41.1696 24.9904 41.2938L24.4762 41.5715C24.1895 42.033 24.0695 42.4831 23.9708 42.9361L23.8564 43.4676L23.7961 43.7152L23.7593 43.8533L25.3978 44.3234L26.0569 44.5054L26.1713 44.5352L30.9167 45.8987L30.8069 45.9885C30.7478 46.0359 30.6807 46.0874 30.596 46.1439L30.0858 46.4755L29.5638 46.8005L29.1408 47.0563L27.2406 48.176L26.8327 48.4208L26.435 48.6653L26.0497 48.9099C25.6714 49.1548 25.3152 49.4006 24.9914 49.6497L24.745 50.0719C23.4873 52.2366 22.6652 54.7321 22.1831 58.0443L22.0723 58.8482L22.0204 59.2567L21.8315 60.3112C15.7417 57.7915 10.7817 53.45 7.66626 47.6272L8.11081 46.8696L8.52286 46.1557L9.02374 45.2715L9.47179 44.4638L9.86983 43.7321L10.5973 42.3598L11.2918 41.0349L11.4012 40.8374L11.4339 40.7805C13.1134 37.8882 15.5742 34.6756 17.5517 32.9307C17.78 32.7293 18.0173 32.5349 18.2624 32.3474L18.3592 32.1984L18.5478 31.894L18.7472 31.5598L18.9612 31.1905L19.4836 30.2727L19.634 30.0164L19.8362 29.685C20.8596 28.0456 22.0769 26.6695 23.8994 25.2717L24.272 24.9918C24.907 24.5245 25.6123 24.0526 26.403 23.5657L26.8879 23.2716L27.5239 22.8982L28.333 22.4402L29.0471 22.0491C30.2869 21.3796 31.8348 21.8418 32.5043 23.0817Z"
        fill="#FFC8E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7572 43.8719V43.8497C23.7572 43.8497 24.4409 44.051 24.9153 44.1786C25.2583 44.2824 25.5574 44.3805 26.1572 44.5314C25.3367 47.0756 23.0315 49.4809 19.6936 49.3113C21.9894 48.7154 22.9914 46.8717 23.4267 45.4704L23.4959 45.2348L23.5548 45.0098L23.6042 44.7973L23.6624 44.5059L23.6917 44.3327L23.7144 44.1786L23.7475 43.8893L23.7572 43.8719ZM27.2861 29.0994L26.8508 31.5407L26.3495 33.9124C26.0693 34.0124 22.3273 35.89 22.1839 35.9561C22.0405 36.0223 21.918 35.9561 21.918 35.9561L21.9495 35.8L21.9938 35.6133L23.3976 32.9202C24.4015 31.2576 27.2861 29.0994 27.2861 29.0994Z"
        fill="#FFB4DE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4086 34.7796C24.4531 34.9266 24.3699 35.0817 24.2229 35.1262C22.1578 35.7504 19.7519 37.2113 18.7963 38.3732C18.6987 38.4918 18.5235 38.5089 18.4049 38.4113C18.2863 38.3138 18.2692 38.1386 18.3668 38.02C19.3981 36.766 21.8982 35.2479 24.062 34.5939C24.209 34.5494 24.3642 34.6326 24.4086 34.7796ZM26.9536 31.019L26.8068 31.7562L26.7513 32.0196C26.6765 32.181 26.5724 32.3793 26.4507 32.5978L26.2564 32.9386L26.0445 33.2974L25.7127 33.8419L25.495 34.191C25.4178 34.3139 25.2476 34.3556 25.1148 34.284C24.9821 34.2125 24.9371 34.0549 25.0144 33.9319L25.9344 32.4502L26.1445 32.1197L26.3446 31.8148C26.5721 31.4759 26.7773 31.1992 26.9536 31.019Z"
        fill="#003CE5"
      />
    </svg>
  );
};

export default HandDocumentMoneyWhite;
